import CPLOGO_PRIMARY from '/public/images/logos/cplogo-primary.svg';
import CPLOGO_WHITE from '/public/images/logos/cplogo-white.svg';
import CPLOGO_ICON_PRIMARY from '/public/images/logos/cplogo-icon-primary.svg';
import CPLOGO_ICON_WHITE from '/public/images/logos/cplogo-icon-white.svg';
import GOOGLE_LOGO from '/public/images/logos/icons8-google.svg';
import MICROSOFT_LOGO from '/public/images/logos/icons8-microsoft.svg';
import FACEBOOK_LOGO from '/public/images/logos/icons8-facebook.svg';
import SIGNUP_BG from '/public/images/signup.webp';

import LEVEL_0 from '/public/images/levels/level_0.svg';
import LEVEL_1 from '/public/images/levels/level_1.svg';
import LEVEL_2 from '/public/images/levels/level_2.svg';
import LEVEL_3 from '/public/images/levels/level_3.svg';
import LEVEL_4 from '/public/images/levels/level_4.svg';
import LEVEL_5 from '/public/images/levels/level_5.svg';
import LEVEL_6 from '/public/images/levels/level_6.svg';
import LEVEL_7 from '/public/images/levels/level_7.svg';
import LEVEL_8 from '/public/images/levels/level_8.svg';
import LEVEL_9 from '/public/images/levels/level_9.svg';
import LEVEL_10 from '/public/images/levels/level_10.svg';

import POWERED_BY_STRIPE from '/public/images/logos/powered-by-stripe.png';
import MASTERCARD from '/public/images/logos/mastercard.png';
import VISA from '/public/images/logos/visa.png';
import GCASH from '/public/images/logos/gcash.svg';
import IPAYMU from '/public/images/logos/ipaymu.webp';

import ACCOUNT_BANNER from '/public/images/account-banner.webp';
import ACCOUNT_BANNER2 from '/public/images/account-banner-2.webp';

const IMAGE_CONSTANTS = {
	CPLOGO_PRIMARY,
	CPLOGO_WHITE,
	CPLOGO_ICON_PRIMARY,
	CPLOGO_ICON_WHITE,
	SSO: {
		GOOGLE_LOGO,
		MICROSOFT_LOGO,
		FACEBOOK_LOGO,
	},
	SIGNUP_BG,
	LEVELS: {
		0: LEVEL_0,
		1: LEVEL_1,
		2: LEVEL_2,
		3: LEVEL_3,
		4: LEVEL_4,
		5: LEVEL_5,
		6: LEVEL_6,
		7: LEVEL_7,
		8: LEVEL_8,
		9: LEVEL_9,
		10: LEVEL_10,
	},
	POWERED_BY_STRIPE,
	MASTERCARD,
	VISA,
	GCASH,
	IPAYMU,
	ACCOUNT_BANNER,
	ACCOUNT_BANNER2,
};

export default IMAGE_CONSTANTS;
